import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import * as styles from "../styles/image-text-blocks.module.scss"
import Rich from "./rich"

const ImageText = props => (
  <section
    className={`${styles.imageText} ${
      props.background === "off-white" ? "fog" : props.background === "dark" ? "dark" : ""
    }`}
  >
    <div className={`container ${props.big ? 'big' : ''}`}>
      {props.display && (
        <header>
          <h2>{props.title}</h2>
          {props.subtitle ? <p>{props.subtitle}</p> : ""}
        </header>
      )}
      {props.blocks.map(el => (
        <div className={styles.block} key={el.id}>
          <GatsbyImage
            image={el.image.gatsbyImageData}
            alt={el.image.description}
          />
          <div>
            <Rich text={el.text} />
          </div>
        </div>
      ))}
    </div>
  </section>
)

export default ImageText
